<script>
export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    token: {
      type: [String],
      required: true
    },
    api: {
      type: [String],
      default: 'https://api.flyo.cloud/integration/embed'
    },
    cache: {
      type: [String],
      default: ''
    }
  },
  data:() => ({
    isLoading: true,
    items: [],
    config: {
      intro: null,
      outro: null,
      searchable: 0,
      bg_color: null,
      search_input_color: null,
      button_color: null,
      card_radius: null,
      search_input_radius: null,
      button_radius: null,
      md_grid_col: null,
      lg_grid_col: null,
      xl_grid_col: null,
      xxl_grid_col: null,
      primary_cta_target: null,
      secondary_cta_target: null
    },
    query: '',
  }),
  computed: {
    fetchUrl : function() {
      let url = `${this.api}/${this.id}/${this.token}`
      if (this.cache.length > 0) {
        url = url + '?' + this.cache + '=' + Date.now()
      }
      return url 
    },
    buttonRadius: function() {
      return this.config.button_radius || 'rounded-lg'
    },
    searchInputRadius: function() {
      return this.config.search_input_radius || 'rounded-lg'
    },
    cardRadius: function() {
      return this.config.card_radius || 'rounded-lg'
    },
    introText: function() {
      return this.config.intro
    },
    outroText: function() {
      return this.config.outro
    },
    noResultsText: function() {
      return this.config.no_results_text || 'Keine Treffer für die Suche gefunden.'
    },
    searchable: function() {
      return this.config.searchable || false
    },
    rows: function() {
      return this.items.filter(item => {
        return item.title?.toLowerCase().includes(this.query.toLowerCase()) || item.text?.toLowerCase().includes(this.query.toLowerCase()) || item.teaser?.toLowerCase().includes(this.query.toLowerCase()) 
      })
    },
    mdGridCol: function() {
      return this.config.md_grid_col || 6
    },
    lgGridCol: function() {
      return this.config.lg_grid_col || 4
    },
    xlGridCol: function() {
      return this.config.xl_grid_col || 3
    },
    xxlGridCol: function() {
      return this.config.xxl_grid_col || 2
    }
  },
  created() {
    fetch(this.fetchUrl)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json()
    })
    .then(data => {
      this.items = data.items
      this.config = data.config.code_config
      this.isLoading = false
    })
    .catch((error) => {
      console.error('Flyo Embed Server Error', error);
    });
  },
  methods: {
    filterImage(item) {
      if (item.image) {
        // a filter has already been applied
        if ((item.image.includes('/filter/') || item.image.includes('/thumb/'))) {
          return item.image
        }
        return `${item.image}/filter/350x350`
      }

      return false
    },
    gridClasses(inverse) {
      return this.generateGridClasses(this.mdGridCol, this.lgGridCol, this.lgGridCol, this.xxlGridCol, inverse)
    },
    generateGridClasses(md, lg, xl, xxl, inverse) {
      // config:
      // md: 6 => 6/12
      // lg: 4 => 4/12
      // xl: 3 => 3/12
      // 2xl: 2 => 2/12

      // if inverse is enabled, the opposite rows is calculated from the grid config (like the B col in a grid A|B)
      if (inverse === true) {
        md = 12-md;
        lg = 12-lg;
        xl = 12-xl;
        xxl = 12-xxl;
      }
      return [
        `md:w-${md}/12`,
        `lg:w-${lg}/12`,
        `xl:w-${xl}/12`,
        `2xl:w-${xxl}/12`
      ]
    }
  }
}
</script>
